
export default {
    name:'CertificateLookup',
    data(){
        return{
            sid:null,
            inputSid:null,
            loading:false,
            hasResult:false,
            showResult:false,
            result:{}
        }
    },
    mounted() {
        console.log(this.$route.query.id);
        if(this.$route.query.id){
            this.sid = this.$route.query.id
            this.getStsInfo()
        }
    },
    methods: {
        async getStsInfo() {
            const id = this.sid || this.inputSid

            // Validate before hitting the API
            const parsed = parseInt(id, 10)
            if (!id || isNaN(parsed) || parsed <= 0 || parsed > 2147483647) {
                this.result = { error: true }
                this.showResult = true
                this.loading = false
                return
            }

            this.loading = true;
            this.showResult = false;

            try {
                this.result = await this.$axios.$post(`${process.env.DATA_URL}/customers/passed_courses`, {
                    customer_id: parsed // send the parsed int, not the raw string
                });

                if (!this.result.error) {
                    this.showResult = true;
                }
            } catch (error) {
                console.error('Error fetching STS info:', error);
                this.result = { error: true };
            } finally {
                this.loading = false;
            }
        }
    }
}
